import React from "react";
import style from "./index.module.scss";
import { Button, Col, Modal, Row, Tooltip } from "antd";
import classNames from "classnames";
import SourceInfo from "./Components/SourceInfo";
import DeleteConfirm from "../../../../../components/DeleteConfirm";
import {
    GetMeetingListItemData,
    SaveMeetingData,
    saveMeetingRecording
} from "../../../../../service/meeting";
import Style from "../../../Resource/Components/LocalModal/index.module.scss";
import ListItem from "../../../../../components/CourseComponents/Resource/UploadIndicator/components/ListItem";
import useUploadGen from "../../../../../utils/v2/useUploadGen";
import { useToggle } from "react-use";
import useRequestFn from "../../../../../utils/useRequestFn";
import { ResultMessage } from "../../../../../components/ResultMessage";
import { errorMessage } from "../../../../../service/service";

import { CourseWareTypeList } from "../../../../../utils/common";
import FileSelect from "../../../../../components/ChainUpload/Components/FileSelect";

interface Props {
    rowItem: GetMeetingListItemData;
    onDelete: (id: string) => void;
    onEdit: (id: string) => void;
    reload: () => void;
}
export default function MeetingListItem({
    onDelete,
    onEdit,
    rowItem,
    reload
}: Props) {
    const { cancel, onFileChange, uploadLoading, fileList } = useUploadGen({
        nextType: { video: CourseWareTypeList.video }
    });

    const [visible, toggleVisible] = useToggle(false);

    function beforeCancel() {
        cancel?.();
        toggleVisible?.();
    }

    function onUploadBefore(files: File[]) {
        if (files.length > 0) {
            toggleVisible(true);
            onFileChange(files);
        }
    }

    const [bindMeeting, { loading: bindLoading }] =
        useRequestFn(saveMeetingRecording);

    async function uploadSubmit() {
        toggleVisible(false);
        const postParams: SaveMeetingData[] = fileList
            .filter(item => item.status === "done")
            .map(item => {
                return {
                    meetingId: rowItem.id,
                    name: item.file.name,
                    fileKey: item.response?.key || ""
                };
            });
        try {
            await bindMeeting(postParams);
            await reload();
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    return (
        <div className={classNames(style.root)}>
            <Row
                type="flex"
                align="middle"
                justify="space-between"
                style={{ height: "100%" }}>
                <Col span={12} className={style.left}>
                    <div className={style.titleRow}>
                        <h1 className={style.title}>
                            <Tooltip title={rowItem.title}>
                                {rowItem?.id}
                                <span className={style.over}>
                                    {rowItem.title}
                                </span>
                            </Tooltip>
                        </h1>
                    </div>

                    <SourceInfo reload={reload} item={rowItem} />
                </Col>
                <Col>
                    <div className={style.tools}>
                        <FileSelect
                            loading={bindLoading}
                            buttonClass={Style.fileBtn}
                            key={uploadLoading.toString()}
                            onFileSelect={files => onUploadBefore(files)}>
                            <div className={classNames(style.button)}>
                                上传回放
                            </div>
                        </FileSelect>
                        <Button
                            type="link"
                            target="_blank"
                            href={rowItem.url}
                            className={classNames(style.button)}>
                            进入会议
                        </Button>
                        <Button
                            type="link"
                            onClick={() => onEdit(rowItem.id)}
                            className={classNames(style.button)}>
                            修改会议
                        </Button>
                        <DeleteConfirm
                            title={`确定删除吗？`}
                            content={`会议主题：${rowItem.title}`}
                            onSuccess={() => {
                                onDelete?.(rowItem.id);
                            }}>
                            <Button
                                type="link"
                                className={classNames(style.button)}>
                                删除会议
                            </Button>
                        </DeleteConfirm>
                    </div>
                </Col>
            </Row>

            <Modal
                visible={visible}
                okButtonProps={{ loading: uploadLoading }}
                onOk={uploadSubmit}
                width={800}
                onCancel={beforeCancel}>
                <div className={style.uproot}>
                    <div className={style.upList}>
                        {Array.from(fileList).map((item: any) => {
                            return <ListItem key={item.uid} file={item} />;
                        })}
                    </div>
                </div>
            </Modal>
        </div>
    );
}
